import * as tslib_1 from "tslib";
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
var Queries = /** @class */ (function () {
    function Queries() {
    }
    Queries.prototype.getLabels = function () {
        return gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query getLabels ($where: LabelWhereInput, $offset: Int) {\n        labels (where: $where, orderBy: { column: name, direction: asc }, limit: 50, offset: $offset) {\n          items {\n            id\n            name\n            color\n          }\n        }\n      }\n    "], ["\n      query getLabels ($where: LabelWhereInput, $offset: Int) {\n        labels (where: $where, orderBy: { column: name, direction: asc }, limit: 50, offset: $offset) {\n          items {\n            id\n            name\n            color\n          }\n        }\n      }\n    "])));
    };
    Queries.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Queries_Factory() { return new Queries(); }, token: Queries, providedIn: "root" });
    return Queries;
}());
export { Queries };
var templateObject_1;
